<template>
  <div>
    <div class="tr1">
      <div class="th1" @click="opendate">日期：{{date}}</div>
      <van-popup v-model="show" round position="bottom" :style="{ height: '40%' }">
        <van-datetime-picker @confirm="confirmdate" @cancel="canceldate" v-model="currentDate" type="date" title="选择年月日" :min-date="minDate"
          :max-date="maxDate" />
      </van-popup>

    </div>
    <div class="tablebox">
      <div class="table">

        <div class="tr">

          <div class="th" v-for="(item,index) in thList">{{item}}</div>
        </div>
        <div class="tr" v-for="(item,index) in projectcountlist">
          <div class="td">{{item.project_name}}</div>
          <div class="td">{{item.nums}}</div>
          <div class="td">{{item.amount}}</div>
        </div>
      </div>
    </div>
    <div class="tablenone"></div>
  </div>
</template>

<script>
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  var phone_mreg = /^1[2-9][0-9]{9}$/;
  export default {
    data() {
      return {
        thList: ['项目', '数量', '金额'],
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
        date: "",
        show: false,
        projectcountlist:[]
      }
    },
    created() {
      let d = new Date()
      let d1 = new Date()
      d1.setDate(d.getDate()-1)
      let resDate = this.formatDate(d1)
      this.date = resDate
      console.log("date",this.date)
      this.request("getprojectcount", {
        date: this.date
      })
    },
    methods: {
      formatDate(date){
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
         month = month<10 ? ('0'+ month) : month
         day = day<10 ? ('0'+day) : day
         return year+'-'+month+'-'+day
      },
      opendate() {
        this.show = true
      },
      confirmdate(e) {
        console.log("e", e)
        let d = new Date(e)
        let resDate =this.formatDate(d)
        this.date = resDate
        // this.currentDate = resDate
        this.request("getprojectcount", {
          date: this.date
        })
        console.log("date",this.date)
        this.show = false
      },
      canceldate(e) {
        this.show = false
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          case 'getprojectcount':
            httper.get('sys/date-project-count', requestData, res => {
              if (res.code === 0) {
                  this.projectcountlist = res.data
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, false)
            break
        }
      },

    }
  }
</script>

<style>
  .tablebox {
    width: 100%;
    margin-bottom: 20px;
  }

  .table {
    width: 100%;
    border-radius: 4px;
    display: table;
    /* 此元素会作为块级表格来显示（类似 <table>），表格前后带有换行符 */
    table-layout: fixed;
    /* fixed 列宽由表格宽度和列宽度设定 auto 列宽度由单元格内容设定 */
    border-collapse: collapse;
    /* 边框会合并为一个单一的边框 */
    overflow-x: auto;
    word-break: keep-all;
    /* 只能在半角空格或连字符处换行  break-all 允许在单词内换行*/

  }

  .tr {
    display: table-row;
    /* 此元素会作为一个表格行显示 */
  }

  .tr1 {
    width: 100%;

    /* 此元素会作为一个表格行显示 */
  }

  .th1 {
    width: 100%;
    /* display: table-cell; */
    height: 50px;
    border-bottom: 1px solid #E5E5E5;
    /* vertical-align: middle; */
    /* 把此元素放置在父元素的中部 */
    background-color: #EEEEEE;
    color: #666666;
    font-size: 15px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 规定段落中的文本不进行换行 */
  }

  .th {
    display: table-cell;
    /* 此元素会作为一个表格单元格显示（类似 <td> 和 <th>） */
    height: 30px;
    text-align: center;
    border: 1px solid #E5E5E5;
    vertical-align: middle;
    /* 把此元素放置在父元素的中部 */
    background-color: #EEEEEE;
    color: #666666;
    font-size: 14px;
    white-space: nowrap;
    /* 规定段落中的文本不进行换行 */
  }

  .td {
    display: table-cell;
    /* 此元素会作为一个表格单元格显示（类似 <td> 和 <th>） */
    height: 30px;
    text-align: center;
    border: 1px solid #E5E5E5;
    vertical-align: middle;
    white-space: nowrap;
    /* 规定段落中的文本不进行换行 */
  }
  .tablenone{
    width: 100%;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/table/table.vue